import clsx from 'clsx';
import { FC } from 'react';
import { ReactComponent as ArrowRight } from '../../assets/icon/arrow_right.svg';
import { Route } from '../../constants/Route';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { Icon } from '../Icon';
import { Link } from '../Link.client';

interface GuideMenuItem {
  name: string;
  title: string;
  description: string;
  route: Route;
  icon: string;
}

const GuideMenuItems: GuideMenuItem[] = [
  {
    name: 'SHIPPING',
    title: '送料 全国一律￥980',
    description: '全国一律￥980でお届けいたします。',
    route: { route: 'shipping' },
    icon: 'Shipping',
  },
  {
    name: 'PAYMENT',
    title: 'お支払い方法',
    description: 'クレジットカードの他にも代引き等、各種お支払い方法をご用意。',
    route: { route: 'payment' },
    icon: 'Card',
  },
  {
    name: 'CANCEL',
    title: '返品・交換について',
    description: 'キャンセル・返品・交換についてご案内。',
    route: { route: 'refunds' },
    icon: 'Order',
  },
  {
    name: 'FAQ',
    title: 'よくある質問',
    description: 'お問い合わせの多い質問をご案内。？と思ったら、気軽にお問い合わせを。',
    route: { route: 'questions' },
    icon: 'FAQ',
  },
];

export const GuideMenu: FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <section className="pt-8 pb-16">
      <h2 className="mb-8 text-center text-lg">
        <span className="mr-4 font-outfit text-3xl">GUIDE</span>ご利用ガイド
      </h2>
      <div className={clsx('flex flex-wrap justify-center gap-10', isDesktop ? 'wrapper' : '')}>
        {GuideMenuItems.map((item, i) => (
          <GuideItem {...item} key={i} />
        ))}
      </div>
    </section>
  );
};

const GuideItem: FC<GuideMenuItem> = ({ icon, name, title, description, route }) => (
  <div className="relative h-48 w-64 border border-solid border-lightGray">
    <Link {...route}>
      <div className="flex w-full flex-col items-center justify-center px-6 pt-6 text-center">
        <p className="absolute top-[-13px] bg-white px-6 font-outfit font-semibold">{name}</p>
        <div className="mb-4 flex h-11 items-center justify-center">
          <Icon name={icon} />
        </div>
        <div className="mb-3 font-semibold">
          <p>{title}</p>
        </div>
        <div className="text-xs text-gray">
          <p>{description}</p>
        </div>
      </div>
      <div className="absolute -bottom-3 flex w-full justify-center">
        <div className="flex items-end justify-center gap-3 bg-dark px-5 py-1 text-white hover:opacity-80">
          <p className="font-outfit text-[10px] tracking-[1px]">MORE READ</p>
          <div className="mb-1">
            <ArrowRight fill="white" width={13} height={5} />
          </div>
        </div>
      </div>
    </Link>
  </div>
);
